module.exports = __webpack_public_path__ + "static/media/S.71d3aa5f.jpg";